import React, { useContext } from "react";
import { NavigationControl } from "react-map-gl";
import { formatAddressFromAddressParts } from "common/utils/address";
import { GetDocumentUploadQuery } from "../../generated/graphql";
import { AuthContext } from "../Authorization/AuthContext";
import LayeredMap from "../Maps/LayeredMap";
import useViewport from "../Maps/utils/viewportHook";
import {
  Container,
  ExtractedAddressContainer,
  Header,
  LocationSection,
  MapNavigationWrapper,
  ParcelLocation,
  ParcelSection,
  PropertyLocation,
} from "./__styles__/Location";
import { Section } from "./__styles__/Settings";

type ExtractedAddress = {
  streetAddress?: Maybe<string>;
  city?: Maybe<string>;
  state?: Maybe<string>;
  zipcode?: Maybe<string>;
};

const Location = ({
  property,
  extractedAddress,
}: {
  property: NonNullable<
    NonNullable<GetDocumentUploadQuery["documentUpload"]>["property"]
  >;
  extractedAddress?: Maybe<ExtractedAddress>;
}) => {
  const { viewport, setViewport } = useViewport({
    zoom: 17,
    latitude: property.latitude,
    longitude: property.longitude,
  });
  const { account } = useContext(AuthContext);
  const layers = {
    marker: {
      value: { latitude: property.latitude!, longitude: property.longitude! },
    },
    parcels: {}, // nothing provided as to not highlight the 'selected' parcel on the map
  };
  return (
    <React.Fragment>
      <Section>
        <Header>Extracted address</Header>
        <ExtractedAddressContainer>
          <PropertyLocation>{extractedAddress?.streetAddress}</PropertyLocation>
          <PropertyLocation>
            {formatAddressFromAddressParts({
              city: extractedAddress?.city,
              state: extractedAddress?.state,
              zipcode: extractedAddress?.zipcode,
            })}
          </PropertyLocation>
        </ExtractedAddressContainer>
      </Section>
      <Section>
        <Header>Property location</Header>
        <LocationSection>
          <div>
            <PropertyLocation>{property.streetAddress}</PropertyLocation>
            <PropertyLocation>
              {formatAddressFromAddressParts({
                city: property.city,
                state: property.state,
                zipcode: property.zipcode,
              })}
            </PropertyLocation>
          </div>
          <ParcelSection>
            <ParcelLocation>
              Parcel ID: {property.parcel?.parcelId}
            </ParcelLocation>
            <ParcelLocation>
              Block number: {property.parcel?.block}
            </ParcelLocation>
            <ParcelLocation>Lot number: {property.parcel?.lot}</ParcelLocation>
          </ParcelSection>
        </LocationSection>
      </Section>
      <Container>
        <LayeredMap
          width={"100%"}
          height={"297px"}
          setViewport={setViewport}
          viewport={viewport}
          baseMapStyle={account?.defaultBaseMap.mapboxStyle}
          account={account!}
          layers={layers}
        >
          <MapNavigationWrapper>
            <NavigationControl showCompass={false} />
          </MapNavigationWrapper>
        </LayeredMap>
      </Container>
    </React.Fragment>
  );
};

export default Location;
